var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 96H38.818l-3-3V57h6v33H78V57h6v36l-3 3ZM102.183 45H18v6h84.183v-6Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 96H50.818V66H69v30Zm-12.182-6H63V72h-6.182v18Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.183 95.998H15V52c0-3.445 1.645-6.733 4.4-8.8l31.415-23.695L50.81 12h18.183l.005 7.517 30.634 23.458c3.581 2.008 5.551 5.205 5.551 9.025v43.998Zm-6-6V52c0-1.678-.83-2.905-2.613-3.86l-.212-.115L63 22.483V18h-6.185v4.495l-33.81 25.5A5.027 5.027 0 0 0 20.997 52v37.998h78.186Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24h-6v42h6V24ZM72.183 90H48v6h24.183v-6Z",
    fill: "#222",
    className: "fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.877 50.123 60 31.243V27h-.182v4.242l-18.88 18.88-4.243-4.245 17.123-17.12V21H66v7.758l17.123 17.12-4.246 4.245Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipi);
export default __webpack_public_path__ + "static/media/tipi.b5463b72.svg";
export { ForwardRef as ReactComponent };